import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { ListBox } from "primereact/listbox";

export default function ParticipantEditor({ results, setResults }) {
  const [newParticipantName, setNewParticipantName] = useState("");
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [removeIndex, setRemoveIndex] = useState(null);

  const removeParticipant = (index) => {
    const updated = results.participants.filter((_, i) => i !== index);
    const newResults = { ...results, participants: updated };
    setResults(newResults); // plain object, works with your wrapper
  };

  const addParticipant = () => {
    if (!newParticipantName.trim()) return;

    const newId = String(Date.now());

    const newParticipant = { id: newId, name: newParticipantName.trim() };

    const newResults = {
      ...results,
      participants: [...results.participants, newParticipant],
    };

    setResults(newResults); // plain object, works with your wrapper
    setNewParticipantName(""); // clear input
  };

  const participantTemplate = (participant) => {
    const index = results.participants.findIndex(
      (p) => p.id === participant.id
    );

    return (
      <div
        className="p-d-flex p-jc-between p-ai-center"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>{participant.name}</span>
        <Button
          icon="pi pi-times"
          className="p-button-text p-button-sm"
          onClick={() => {
            setRemoveIndex(index);
            setConfirmVisible(true);
          }}
        />
      </div>
    );
  };

  return (
    <div>
      <ListBox
        value={results.participants}
        options={results.participants}
        optionLabel="name"
        itemTemplate={participantTemplate}
        emptyMessage="Ei osallistujia"
        style={{ width: "100%", "margin-top": "20px" }}
      />

      <div style={{ display: "flex", gap: "0.5rem", marginTop: "1rem" }}>
        <div className="p-inputgroup flex-1">
          <InputText
            placeholder="Nimi"
            value={newParticipantName}
            onChange={(e) => setNewParticipantName(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && addParticipant()}
            style={{ flexGrow: 1 }}
          />
          <Button
            label=""
            icon="pi pi-plus"
            className="p-button-outlined p-button-sm"
            onClick={addParticipant}
          />
        </div>
      </div>
      <Dialog
        header="Vahvista poisto"
        visible={confirmVisible}
        onHide={() => setConfirmVisible(false)}
        dismissableMask
        footer={
          <div>
            <Button
              label="Poista"
              icon="pi pi-check"
              severity="danger"
              onClick={() => {
                removeParticipant(removeIndex);
                setConfirmVisible(false);
              }}
              autoFocus
            />
            <Button
              label="Peruuta"
              icon="pi pi-times"
              onClick={() => setConfirmVisible(false)}
              className="p-button-text"
            />
          </div>
        }
      >
        {removeIndex != null && (
          <>
            Poistetaanko <b>{results.participants[removeIndex]?.name}</b>?
          </>
        )}
      </Dialog>
    </div>
  );
}
